import { SelectableItem } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

enum painScale {
  RELAXED = 1,
  PARTIAL_TENSE = 2,
  TOTALLY_TENSE = 3,
  MAKE_FACE = 4,
}

export const faceExpressionData: SelectableItem[] = [
  {
    key: String(painScale.RELAXED),
    label: MessageService.translate('text.relaxed'),
    value: String(painScale.RELAXED),
  },
  {
    key: String(painScale.PARTIAL_TENSE),
    label: MessageService.translate('text.partial-tense'),
    value: String(painScale.PARTIAL_TENSE),
  },
  {
    key: String(painScale.TOTALLY_TENSE),
    label: MessageService.translate('text.totally-tense'),
    value: String(painScale.TOTALLY_TENSE),
  },
  {
    key: String(painScale.MAKE_FACE),
    label: MessageService.translate('text.make-face'),
    value: String(painScale.MAKE_FACE),
  },
]
